import { Col } from 'antd';
import { Row } from 'antd';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import CustomCard from '../../../components/Antd/Card';
import CustomTable from '../../../v2-components/Antd/Table';
import { Service } from '../service';
import StatusCard from './components/StatusCard';
import TrackingProgress from './components/TrackingProgress';
import { dictionaryInformation } from './constants/dictionary-information.constant';
import { clientInfoAdapter } from './handle/client-info-adapter.handle';
import { generateClientColumns } from './handle/gererate-client-columns.handle';
import Loading from '../../../v2-components/Loading';
import './style.scss';
import { MagistralProductForm } from './components/MagistralProductForm'
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomMediaViewer from '../../../v2-components/CustomMediaViewer';

export default function QuotationDetailAdminPage() {
	const { id } = useParams();
	const [data, setData] = useState();
	const [isError, setError] = useState(false);
	const [renderData, setRenderData] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const { email } = GetLocalStorageValue('userInfo')
	const [products, setProducts] = useState([])

	const status = data?.[0]?.status;
	const dataClient = data?.[0]?.quotation?.user_info;
	const statusNumber = data?.[0]?.status?.status;
	const magistralProducts = data?.[1]?.magistral_products?.map((product) => ({ key: product._id, name: product.name, specs: product.specs, price: product.price, quantity: product.quantity }))

	useEffect(() => {
		console.log('useEffect pagina principal');
		setRenderData(false);
		new Service().getDataById(id)
			.then((dataResponse) => {
				setData(dataResponse);
				setIsLoading(false)
				setRenderData(false);
			})
			.catch((error) => {
				setIsLoading(false);
				setError(true);
			});
	}, [id, renderData]);



	if (isError) {
		return (
			<>
				<Row>
					<Col span={8}>
						<h2>Lo sentimos...</h2>
						<h3>{`La Solicitud N° ${id} no existe`} </h3>
						{/* <Link to={checkRol()}>Volver a cotizaciones</Link> */}
						<Link to={'quotation?status=requested&page=1'}>Volver a cotizaciones</Link>
					</Col>
				</Row>
			</>
		);
	}

	const handleApproveQuotation = () => {
		setIsLoading(true)
		const productsCopy = [...products]
		delete productsCopy[0].key
		if (!productsCopy[0].specs) {
			delete productsCopy[0].specs
		}
		const body = {
			tracking_id: data?.[0]?._id,
			status_target: 300,
			qf_email: email,
			data_approve: {
				estimated_date: new Date().toISOString(),
				price: products[0].price,
				quantity: products[0].quantity,
			},
			magistral_products: productsCopy
		}
		new Service().processNewStatus(body).then((response) => {
			console.log('response', response)
			setIsLoading(false)
			setRenderData(true)

		}).catch((error) => {
			console.log('error', error)
			setIsLoading(false)
		}
		)
	}
	const handleCancelQuotation = () => {
		setIsLoading(true)
		const productsCopy = [...products]
		delete productsCopy[0].key
		if (!productsCopy[0].specs) {
			delete productsCopy[0].specs
		}
		const body = {
			tracking_id: data?.[0]?._id,
			status_target: 500,
			qf_email: email,
			data_approve: {
				estimated_date: new Date().toISOString(),
				price: products[0]?.price,
				quantity: products[0]?.quantity,
			},
			magistral_products: productsCopy
		}
		new Service().processNewStatus(body).then((response) => {
			setIsLoading(false)
			setRenderData(true)

		}).catch((error) => {
			console.log('error', error)
			setIsLoading(false)
		}
		)
	}

	const handleSetProducts = (products) => {
		setProducts(products)
	}


	if (isLoading) {
		return <Loading />;
	}
	return (
		<div className="ph-tracking-order-detail-page-container">
			<Row>
				<Col span={8}>
					<h2>{`Solicitud N° ${data?.[0]?.quotation?.short_code?.split(" ")[0]}`} </h2>
					<Link to={`/admin-quotation?status=requested&page=1&pharmacy=${data?.[0]?.quotation?.pharmacy[0]}`}>Volver a cotizaciones</Link>
					{/* <Link to={checkRol(data?.[0]?.quotation?.pharmacy[0])}>Volver a cotizaciones</Link> */}
				</Col>
			</Row>
			<Row>
				<Col span={12}>
					<TrackingProgress data={data?.[0]} />
				</Col>
				<Col span={12}>
					<CustomCard >
						<StatusCard
							products={products}
							statusNumber={statusNumber}
							status={status}
							handleCancelQuotation={handleCancelQuotation}
							handleApproveQuotation={handleApproveQuotation}
						/>
					</CustomCard>
				</Col>
				<Col span={24} style={{ marginBottom: '25px' }}>
					<h3>{dictionaryInformation[Enviroment.LANGUAGE].client}</h3>
					<CustomTable columns={generateClientColumns()} pagination={false} dataSource={clientInfoAdapter(dataClient)} />
				</Col>
				<Col span={16}>
					<MagistralProductForm products={products} handleSetProducts={handleSetProducts} currentStatus={statusNumber} magistralProducts={magistralProducts} />
				</Col>
				<Col span={6}>
					<div className="custom-image-container">
						<CustomMediaViewer src={data?.[0]?.quotation?.recipe_url} />
					</div>
				</Col>
			</Row>
		</div>
	);
}
